/**
 * GİRDİ TAVANI VE GÜVENLİ KESİM — `email-mask.ts`in SINIR YARISI, AYRI DOSYA.
 *
 * NEDEN AYRI (sekizinci dalga, 16.09.2026): `email-mask.ts` kaynak tavanını
 * (500 satır) aştı. Ayrım kavramsaldır: BURASI "metnin NEREDEN kesileceği"
 * sorusunu cevaplar, `email-mask.ts` "hangi okunuşlarda taranıp ne döneceği"ni.
 * Kamuya açık sabitler `email-mask.ts`ten yeniden dışa verilir.
 */
/**
 * Bu desenin beslendiği EN GENİŞ kolonun karakter sınırı
 * (`email_deliveries.last_error varchar(500)`; ikincisi
 * `provider_message_id varchar(255)`).
 *
 * BU SAYI BİR TAVAN DEĞİL, BİR ÖLÇÜ TABANIDIR: desende tavan YOKTUR (tırnaklı
 * yerel ad sınırsızdır) ve tavanı aşan yerel ad da maskelenir — tavanlı bir
 * desen tanım gereği fail-open olur. Sayı yalnız EN KÖTÜ GİRDİYİ kurmak için
 * kullanılır ve kolonla tutarlılığını
 * `apps/api/src/modules/mail/email-mask-ceiling.guard.spec.ts` entity VE
 * migration SQL'inden okuyarak denetler: kolon genişletilirse test KIRILIR.
 */
export const EMAIL_MASK_SOURCE_CEILING = 500;
/**
 * MASKELEMEYE GİREN METNİN ÜST SINIRI — KOLONDAN TÜRER, ELLE YAZILMAZ.
 *
 * KOLON 500 KARAKTER AMA MASKELEME KOLONDAN ÖNCE KOŞAR: `queueErrorText`
 * sağlayıcının YAZDIĞI metni alır ve o metnin uzunluğu bizim elimizde değildir
 * (bir HTTP sağlayıcısının hata gövdesi HTML sayfası olabilir). Desen
 * eşleşmeyi HER başlangıç noktasından dener, yani maliyet girdi uzunluğunda
 * KARESEL — ölçüldü: 500 karakter 0,75 ms · 2000 karakter 11,8 ms · 100 KB ise
 * işçi iş parçacığını dakikalarca kilitlerdi. Kuyruk işçisi tek iş parçacığıdır;
 * bu bir kullanılabilirlik açığıdır.
 *
 * KESME MASKELEMEDEN ÖNCE YAPILIR VE FAIL-CLOSED'DİR: kesilen KUYRUK metne
 * hiç girmez, yani taranmamış bir parça çıktıya sızamaz.
 */
export const EMAIL_MASK_INPUT_LIMIT = EMAIL_MASK_SOURCE_CEILING * 4;
/** Kesme işareti — panelde aynen görünür. */
export const EMAIL_MASK_TRUNCATION = '…';
/**
 * GİRDİ TAVANINDA GÜVENLİ KESİM NOKTASI — SINIR ADRES DİLBİLGİSİNDEN TÜRER.
 *
 * KUSUR ÖLÇÜLDÜ (QA, 16.09.2026 · 19 ofset): kesim tam olarak adresin yerel
 * adının içine denk geldiğinde (`…sinirali` ve `…sinirali@`) baştaki parçada
 * `@` ya hiç yoktu ya da alanı yoktu; desen eşleşmiyor, yerel ad HAM kalıyordu.
 *
 * SEKİZİNCİ DALGA — ÇÖZÜM YALNIZ BİTİŞİK YAZIMI KAPATMIŞTI (tech-lead,
 * 16.09.2026). Eski hâl "son BOŞLUKSUZ simgeyi at" diyordu; oysa beşinci
 * dalgadan beri adres BOŞLUK TAŞIYABİLİYOR (`ali @ ornek.com`,
 * `ali at ornek dot com`, `ali<NBSP>@ornek.com`). Ölçüldü — üç yazımın üçünde
 * de yerel ad sızıyordu, `at ornek dot` yazımında alan adının bir parçası da:
 *   `…qauser8 …` · `…qauser8 at ornek dot …`
 * Yani simge sınırı BOŞLUKTAN değil, ADRESİN DİLBİLGİSİNDEN türemeliydi.
 *
 * YÖNTEM: atılan metnin BAŞI bir PENCERE kadar görülür ve kesimin adresi bölüp
 * bölmediği ona bakılarak bilinir — tahminle değil. Sınır GÜVENLİ değilse son
 * simge atılır, atılan simge devamın parçası olur ve soru yeniden sorulur.
 * Her tur bir simge eksilttiği için döngü sonludur.
 *
 * FAZLA YEMEZ (md. 1c ters ayak): devam adresi BAĞLAYAMIYORSA (sıradan bir
 * boşluk + sözcük) hiçbir şey atılmaz — `x…x kuyruk` kesiminde baştaki metnin
 * tamamı korunur ve 13. AYAK bunu asertler.
 */
const KUYRUK_SIMGESI = /\s*\S+\s*$/u;
/** Kalan metin `@` ile bitiyor mu (ara boşluk/görünmez karakter serbest)? */
const KALAN_AT_ILE_BITIYOR = /[@＠][\s\p{Cf}]*$/u;
/**
 * `at`/`dot` bağlacı — ÇIPLAK ya da AYRAÇLI. Ayraçlı yazım (`(at)`, `[dot]`)
 * çözücülerin tanıdığı bir biçimdir; kesim sınırında tanınmazsa sınır güvenli
 * sayılır ve yerel ad ham kalır (ölçüldü: `qakesim (at) ornek (dot) com`
 * yazımında 14-25. ofsetler sızıyordu).
 */
const BAGLAC = String.raw `[([{<]?[ \t]*(?:at|ät|dot|nokta)[ \t]*[)\]}>]?`;
/** Kalan metin bağlaçla bitiyor mu (sözcük yazımı)? */
const KALAN_BAGLAC_ILE_BITIYOR = new RegExp(String.raw `[\s]${BAGLAC}[\s]*$`, 'iu');
/** Devam `@` ile başlıyor mu? */
const DEVAM_AT_ILE_BASLIYOR = /^[\s\p{Cf}]*[@＠]/u;
/**
 * Devam bağlaçla başlıyor mu? BAŞTAKİ BOŞLUK SEÇMELİDİR: kesim tam bağlacın
 * önündeki boşluğa denk geldiğinde boşluk KALAN tarafta kalır ve zorunlu
 * tutulsaydı `…qauser8 |at ornek dot com` sınırı güvenli sayılırdı (ölçüldü:
 * 8. ve 17. ofsette yerel ad sızıyordu).
 */
const DEVAM_BAGLAC_ILE_BASLIYOR = new RegExp(String.raw `^[\s]*${BAGLAC}(?:[\s]|$)`, 'iu');
/**
 * TIRNAKLI YEREL AD KAPANMAMIŞ MI? (`"ali veli"@ornek.com`)
 *
 * Tırnaklı yerel ad BOŞLUK TAŞIR ve desende tavanı yoktur; kesim onun içine
 * denk geldiğinde kalan parça (`"qakesim`) simge sınırında durur ve sıradan bir
 * sözcük gibi görünür. Kapanmamış tırnak, devamın `…"@alan` getirebileceğini
 * söyleyen TEK işarettir. Tanı maliyeti sınırlıdır: en çok bir dize değeri
 * kırpılır ve zaten kesilmiş metnin SONUNDA olur.
 */
function tirnakAcik(metin) {
    return (metin.match(/"/gu)?.length ?? 0) % 2 === 1;
}
/**
 * Atılan metnin BAŞINDAN okunan pencere. Sabit ve küçüktür: taranmayacak metnin
 * tamamını okumak kesmenin (karesel maliyet) sebebini ortadan kaldırırdı.
 * Pencere yalnız "bu sınır adresi bölüyor mu" sorusunu cevaplar ve cevabı
 * `[ \t]?@[ \t]?` ile ` at `/` dot ` bağlaçlarına sığar.
 */
const KESIM_PENCERESI = 12;
function sinirBoluyor(kalan, devam) {
    // Sınır bir simgenin ORTASINDA: iki yanı da boşluksuz.
    if (/\S$/u.test(kalan) && /^\S/u.test(devam))
        return true;
    return (KALAN_AT_ILE_BITIYOR.test(kalan) ||
        DEVAM_AT_ILE_BASLIYOR.test(devam) ||
        KALAN_BAGLAC_ILE_BITIYOR.test(kalan) ||
        DEVAM_BAGLAC_ILE_BASLIYOR.test(devam) ||
        tirnakAcik(kalan));
}
export function guvenliKesim(value) {
    let kalan = value.slice(0, EMAIL_MASK_INPUT_LIMIT);
    let devam = value.slice(EMAIL_MASK_INPUT_LIMIT, EMAIL_MASK_INPUT_LIMIT + KESIM_PENCERESI);
    while (sinirBoluyor(kalan, devam)) {
        const kirpik = kalan.replace(KUYRUK_SIMGESI, '');
        if (kirpik === kalan)
            return '';
        devam = `${kalan.slice(kirpik.length)}${devam}`.slice(0, KESIM_PENCERESI);
        kalan = kirpik;
    }
    return kalan;
}
//# sourceMappingURL=email-mask-kesim.js.map